import Typography from "../../base-components/Typography";
import Card from "../../components/Card";
import { ReactComponent as CheckCircle } from "../../assets/icons/check-circle-2.svg";

const Successful = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-8 px-8">
      <img src="/logos/vertical-primary.png" alt="Agula logo" />

      <div className="flex flex-col items-center gap-4 scale-up">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-success-soft">
          <CheckCircle stroke="#0E8C4A" className="h-8 w-8" />
        </div>
        <Typography className="text-center">
          Таны материалыг хүлээн авсан тул энэхүү линк идэвхгүй болсон байна.
          Агула даатгалыг сонгосонд баярлалаа.
        </Typography>
      </div>

      <Card size="sm" className="w-full">
        <Typography variant="Title" size="sm" className="text-black-64 mb-2">
          Холбоо барих
        </Typography>
        <div className="space-y-1">
          <Typography variant="Label" className="text-center">
            Утас: <a href="tel:75751010" className="text-primary">7575-1010</a>
          </Typography>
          <Typography variant="Label" className="text-center">
            Имэйл: <a href="mailto:info@agula.mn" className="text-primary">info@agula.mn</a>
          </Typography>
        </div>
      </Card>
    </div>
  )
}

export default Successful;
